import styles from './Flex.module.scss'
import { classNames } from '@/components/shared/classNames'

export interface Props {
  children: React.ReactNode
  className?: string
  wrap?: boolean
}

export const Flex = ({ children, className, wrap }: Props) => {
  const wrapClass = wrap ? 'flex-wrap' : ''
  return <div className={classNames(styles.flex, wrapClass, className)}>{children}</div>
}
